/* eslint-disable import/no-unassigned-import */
import "swiper/css";
import "swiper/css/a11y";
import React from "react";
import { Swiper, type SwiperProps, SwiperSlide } from "swiper/react";
import { A11y } from "swiper";
import { useToken, Box } from "@chakra-ui/react";

type SliderProps = {
  /** The index of the slide to start on, defaults to the center of the slider. */
  initialSlide?: number;
  children: JSX.Element[];
} & SwiperProps;

export function CenteredSlider({
  children,
  initialSlide = Math.floor(children.length / 2),
  ...swiperProps
}: SliderProps) {
  const slideInlinePadding = useToken("space", "smallest");

  return (
    <Box flexDir="column" pos="relative" maxW="100%">
      <Swiper
        centeredSlides
        slideToClickedSlide
        initialSlide={initialSlide}
        modules={[A11y]}
        slidesPerView="auto"
        {...swiperProps}
      >
        {children.map((slide) => (
          <SwiperSlide key={slide.key} style={{ width: "auto", height: "auto", paddingInline: slideInlinePadding }}>
            {slide}
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
